import React from "react";
import "./ImageSnap.scss";
import ImageSnapProps from "./ImageSnap.types";
import SVG from "../SVG/SVG";

const ImageSnap = (props: ImageSnapProps) => {
  const {
    status = "default",
    icon = "camera",
    image,
    text = "Take Photo",
    isImage = false,
    camera
  } = props;
  const commonImageSnapProp = {
    ...props,
    className: `imageSnap imageSnap--${status} ${
      isImage ? "hide_icon_text show_image" : "show_icon_text hide_image"
    }`,
  };

  const openCameraClick = () => {
    camera();
  }
  return (
    <div className="imgSnap_wrapper">
      <div {...commonImageSnapProp}>
        <div className="outer">
          <div className="icon_text_div">
            <div className="icon_div" onClick={() => openCameraClick()}>
              <SVG type={icon} />
            </div>
            <div className="icon_text">
              <p>{text}</p>
            </div>
          </div>
          <div className="image_div">
            <img src={image} alt="..." onClick={() => openCameraClick()}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageSnap;
